import { fetchGraphql, GraphQLError } from '@zoopla/fetch-graphql';
import {
    NotificationResult,
    QueryNotificationsArgs,
    NotificationFilters
} from '../graphql.generated';
import { filterNotifications, orderNotifications } from './helpers/helpers';
import {
    GetUserNotificationsDocument,
    GetUserNotificationsQuery
} from './queries/notifications/GetUserNotifications.generated';
interface NotificationsOptionsArgument extends NotificationFilters {
    cookie?: string;
    showMojoNotification?: boolean;
}

type GetNotificationsFunction = (
    args: NotificationsOptionsArgument,
    abortSignal?: AbortSignal
) => Promise<[NotificationResult[], GraphQLError[] | undefined]>;

export const getNotifications: GetNotificationsFunction = async (
    { cookie, showMojoNotification, ...args } = {},
    abortSignal
) => {
    const options = cookie
        ? { headers: { Cookie: cookie }, signal: abortSignal }
        : { signal: abortSignal };

    let data: GetUserNotificationsQuery | undefined;
    let errors: GraphQLError[] | undefined;

    try {
        const result = await fetchGraphql<
            GetUserNotificationsQuery,
            QueryNotificationsArgs
        >(GetUserNotificationsDocument, { params: { ...args } }, options);
        data = result.data;
        errors = result.errors;
    } catch (e) {
        // do nothing
    }

    const sortedNotifications = orderNotifications(
        filterNotifications(data?.notifications || [], showMojoNotification)
    );

    return [sortedNotifications, errors];
};
